<template>
	<v-card outlined>
		<v-card-title
			class = "justify-center info pa-0 body-1 primary white--text"
		>	
			<v-icon
				small
				color = "white"
				class = "mr-1"
			>			
				mdi-folder-multiple-image
			</v-icon>
			<span>
				{{ $ml.get('logos') }} 
			</span>
		</v-card-title>
		<v-card-text>
			<v-row>
				<template
					v-for = "(item_field, idx_field) of info_fields"
				>					
					<v-col
						:xl   = "item_field.colss.xl"
						:md   = "item_field.colss.md"
						:cols = "item_field.colss.cols"
					>
						<!-- enctype 	 = "multipart/form-data" -->
						 <v-file-input
						    outlined
						    dense
						    v-model 	 = "info[item_field.key]"
						    :label    	 = "item_field.text"
							prepend-icon = "mdi-camera"							
						  ></v-file-input>	
						  <v-img
						  		contain
						  		v-if  = "info_images[item_field.key]"
						  		:src  = "info_images[item_field.key]"
						  		width = "100"
						  ></v-img>
					</v-col>
				</template>
			</v-row>
		</v-card-text>
		<v-divider></v-divider>
		<v-card-actions>
			<v-progress-circular
				indeterminate
				v-show = "loading"
				color  = "primary"
			></v-progress-circular>
			<v-btn
				x-small
				v-show = "!loading"
				color  = "primary"
				v-text = "$ml.get('save')"
				@click = "save"
			></v-btn>
			<v-spacer></v-spacer>

			<v-btn
				x-small
				v-show = "!loading"
				color  = "error"
				v-text = "$ml.get('delete')"
				@click = "actions('confirm_delete')"
			></v-btn>
		</v-card-actions>
	</v-card>

</template>
<script>
	import EventBus from '@/event-bus'
	export default {
		name  : 'logos',
		props : [],
		data  : () => ({
			info 	: {},
			info_fields : [
				{
					key  : 'login',
					text : 'Login',
					type : 'file',
					colss : {
						xl   : 5,
						md   : 8, 
						cols : 12,
					}
				},
				{
					key  : 'login_night',
					text : 'Login night',
					type : 'file',
					colss : {
						xl   : 5,
						md   : 8, 
						cols : 12,
					}
				},
				
				{
					key  : 'favicon',
					text : 'Favicon',
					type : 'file',
					colss : {
						xl   : 5,
						md   : 8, 
						cols : 12,
					}
				},
				{
					key  : 'logo_light',
					text : 'Logo light',
					type : 'file',
					colss : {
						xl   : 5,
						md   : 8, 
						cols : 12,
					}
				},
				{
					key  : 'logo_night',
					text : 'Logo night',
					type : 'file',
					colss : {
						xl   : 5,
						md   : 8, 
						cols : 12,
					}
				},
				{
					key  : 'background',
					text : 'background',
					type : 'file',
					colss : {
						xl   : 5,
						md   : 8, 
						cols : 12,
					}
				},
			],
			loading 	: false,
			info_images : {
		        'login' : '/img/LogoLogin.png',   // @/assets
		        'login_night' : '/img/LogoLoginNight.png', //@/assets
		        'favicon' : '',
		        'logo_light' : '/img/Logo.png',
		        'logo_night' : '/img/LogoNight.png',
		        'background'  : 'img/bg-grande.png',
		      },	
			list_imgs_check : ['login',
				'login_night',
				'favicon',
				'logo_light',
				'logo_night',
				'background'
			],
			ID_notification : 'logos',
			info_item  : {},

		}), // data		

		created(){
			this.get_list();
		}, // created

		methods : {
			actions(act, item, opt){
				if (act == 'confirm_delete') {
					EventBus.$emit('notifications_modal', {
						type    : 'confirm_delete',
						ID 		: this.ID_notification
					})
				}
			}, // actions

			async save(){
				console.log("IMAGES : ", this.info);
				let info_up 		=  this.info;
				this.loading 		= true; 
				let confirm_save 	= false;
				let list_error 		= '';

				const api 	 = this.$URL + "/api/v1/imagesLogos";
				const config = {  
					headers: { 'Content-Type': 'multipart/form-data'} 
				}; 
			    // files
			    for (let file in info_up) {
			    	console.log("key : " ,file);
					let formData = new FormData();

					let ext = info_up[file] && info_up[file].type ? info_up[file].type.split('/')[1] : 'png';
					console.log("EXT : " , ext)
			        formData.append("file", info_up[file], file + '.' + ext/*, info_up.name*/);
			        // formData.append("name", file);
			        // formData.append("file", file/*, info_up.name*/);
			    	// additional data
			    	// formData.append("test", "foo bar");
					console.log(formData, info_up)
					// console.log("TEST  ",formData.getAll('file'))
					await this.$axios.post(api, formData/*, config */).then(res => {
						console.log("RES logos ", res )
						if (res && res.data) {

							this.info_images[file] = this.$URL + res.data.url_path;
						}
						/**/
					}).catch( er => {
						confirm_save = true;
						list_error += ' ' + file;
						// this.loading = false;
						/*
							er && er.message ? er.message : er
						*/
						console.log("Error logos ", er);
					})
			    } // for

			    this.loading = false;
			    if (!confirm_save) {
			    	this.$EventBus.$emit('notifications_modal', {
						type : 'saved',
					})
			    }else{
			    	this.$EventBus.$emit('notifications_modal', {
						type 	: 'error',
						message : 'Not saved ' + list_error,
					})
			    }
			},

			get_list(){
				/*const { page, itemsPerPage } = this.options;
				let pg = page;*/
				const api 	 = this.$URL + "/api/v1/imagesLogos";
				let check_list = this.list_imgs_check;
				this.$axios.get(api).then(res => {
					console.log("RES logos ", res )
					if (res && res.data) {
						let items = res.data;
						if (items.rows && items.rows.length > 0) {
							items.rows.forEach((img)=>{
								let name = img.name ? img.name.split('.')[0] : null;  
								console.log("NAME : ", name)
								if (name && check_list.indexOf(name)) {
									this.info_images[name] = this.$URL + img.url_path;
								}
							}); // forEach

						}

						// this.info_images[file] = this.$URL + res.data.url_path;
					}
					/**/
				}).catch( er => {
					console.log("Error get LOGOS : ", er);
				})
			}, // get list

			del(item){
				if (item) {

					const api = this.$URL + '/api/v1/imagesLogos/' + 'all' +'/';
					this.$axios.delete(api).then(res => {
						console.log("RES delete logos : ", res);
						this.$EventBus.$emit('notifications_modal',{
							type : 'deleted',
							message : 'All images logos'
						})
						localStorage.removeItem("logos");
					}).catch(er => {
						console.log("Error LOGOS : ", er);
						this.$EventBus.$emit('notifications_modal',{
							type : 'error',
							message : 'Deleting images logos'
						})
					})
				} // item

			}, // del

		}, // methods
		mounted(){
			EventBus.$on('notifications_modal' + this.ID_notification , (action)=>{
				if (action) {
					this.del(action);
				}
			})

			/*const favicon = document.getElementById("favicon");
      		favicon.href = "https://www.google.com/favicon.ico";
			*/
		}
	}; // export default
</script>